var $b6675354d5a6af0b$exports = {};
$b6675354d5a6af0b$exports = {
    "valid": `Ge\xe7erli`
};


export {$b6675354d5a6af0b$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
